import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import HomeIcon from '@mui/icons-material/Home';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import { Button, Stack } from '@mui/material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import Reel from '../tools/Reel';
import React, { useState, useEffect } from "react";
import {
    Box,
    Container,
    Grid,
    Card,
    CardContent,
    Tabs,
    Tab,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Backdrop,
    CircularProgress
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { motion } from "framer-motion";
import FilePreview from '../tools/FilePreview';
const live_events_service = require('../../helpers/live_events_service')

const MotionCard = motion(Card);

const primary = "#0d1e4a";
const dark = "#c9a43b";
const light = "rgba(13,30,74,0.08)";

const levels = {
    diamante: {
        name: "Diamante",
        price: "USD $11,800",
        benefits: [
            "Logotipo en la página del evento con link a su sitio web",
            "Conferencista destacado (conferencia académica 30-40 min, previa aprobación del comité)",
            "Producción y edición de video exclusivo del conferencista para redes sociales EBG",
            "Reconocimiento de marca en medios impresos y digitales (media partners y redes sociales)",
            "Acceso exclusivo a plataforma de Networking con los participantes",
            "Presencia de marca dentro del salón de conferencias y áreas estratégicas",
            "E-mail marketing a base de datos ABG y EBG",
            "Webinar exclusivo (con listado de participantes registrados)",
            "3 gafetes de staff + 1 conferencista (incluye alimentos)",
            "3 participaciones de cortesía",
            "Transmisión de Spot en salón de conferencia (30 segundos a 1 minuto)",
            "Stand 3x2 con Pantalla LED en Salón de Exposición",
        ],
    },
    platino: {
        name: "Platino",
        price: "USD $7,800",
        benefits: [
            "Logotipo en la página del evento con link a su sitio web",
            "Conferencista destacado (conferencia académica 30-40 min, previa aprobación del comité)",
            "Reconocimiento de marca en medios impresos y digitales (media partners y redes sociales)",
            "Acceso exclusivo a plataforma de Networking con los participantes",
            "E-mail marketing a base de datos ABG y EBG",
            "2 gafetes de staff (incluye alimentos)",
            "2 participaciones de cortesía",
            "Stand 3x2 en Salón de Exposición",
        ],
    },
    oro: {
        name: "Oro",
        price: "USD $5,800",
        benefits: [
            "Logotipo en la página del evento con link a su sitio web",
            "Reconocimiento de marca en medios impresos y digitales (media partners y redes sociales)",
            "Acceso exclusivo a plataforma de Networking con los participantes",
            "E-mail marketing a base de datos ABG y EBG",
            "2 gafetes de staff (incluye alimentos)",
            "1 participación de cortesía",
            "Stand 3x2 en Salón de Exposición",
        ],
    },
};

const extras = [
    {
        title: "Cóctail de Bienvenida",
        price: "USD $20,000",
        desc: "Incluye boquitas, bebidas, músico solista y branding del patrocinador. Sin ningún pago adicional. Disponible para 1 empresa.",
    },
    {
        title: "Cena y Fiesta de Clausura",
        price: "USD $25,000",
        desc: "Una experiencia inolvidable en el ambiente Colonial de la Antigua Guatemala. Servicio de cena + fiesta con grupo en vivo + branding exclusivo + palabras especiales del patrocinador + 12 entradas adicionales para invitados estratégicos. Disponible para 1 empresa.",
    },
    {
        title: "Almuerzo Patrocinado",
        price: "USD $15,200 por día",
        desc: "Incluye presentación especial o reel de videos del patrocinador, músico solista contratado por los organizadores. Nivel Diamante incluido. 1 empresa por día.",
    },
    {
        title: "Coffee Breaks",
        price: "USD $13,000 por día",
        desc: "Islas de servicio con su imagen. Nivel Diamante incluido. 1 empresa por día.",
    },
    {
        title: "Carpetas Oficiales",
        price: "USD $18,000",
        desc: "250 carpetas con logotipo impreso de la empresa patrocinadora + el logotipo del congreso. Nivel Diamante incluido. Disponible para 1 empresa.",
    },
    {
        title: "Maletines Oficiales",
        price: "USD $18,000",
        desc: "250 maletines con logotipo impreso de la empresa patrocinadora + el logotipo del congreso. Nivel Diamante incluido. Disponible para 1 empresa.",
    },
    {
        title: "Cintas de Gafetes",
        price: "USD $13,500",
        desc: "Con imagen exclusiva como patrocinador del Congreso en el cinto. Nivel Diamante incluido. Disponible para 1 empresa.",
    },
];

const Patrocinio = () => {
    const [tab, setTab] = useState("diamante");
    const [contador] = useState(0);
    const [loading, setLoading] = useState(true);
    const [url, setUrl] = useState("");
    useEffect(() => {
        live_events_service
            .getData("/evento/view-by-hash/" + process.env.REACT_APP_EVT)
            .then((response_evt) => {
                live_events_service
                    .getData(
                        "/patrocinador/view-by-evento/" +
                        process.env.REACT_APP_EVT
                    )
                    .then((response_patrocinador) => {
                        live_events_service
                            .getData(`/conferencista/read/${process.env.REACT_APP_EVT}`)
                            .then((response) => {
                                setUrl(response_evt.data.response_database.result[0].planos);
                                setLoading(false)
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            })
            .catch((error) => {
                console.log(error);
            });
    }, [contador]);
    return (
        <Stack
            spacing={5}
            alignItems="center"
            sx={{
                background: '#f5f7f6',
                width: '100%',
                overflowX: 'hidden',
            }}
            pt={3}
        >
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Breadcrumbs aria-label="breadcrumb">
                <Link
                    underline="hover"
                    sx={{ display: 'flex', alignItems: 'center' }}
                    color="inherit"
                    href="/"
                >
                    <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                    Inicio
                </Link>

                <Typography
                    sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}
                >
                    <AttachMoneyIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                    Patrocinio
                </Typography>

            </Breadcrumbs>
            <Reel />
            <Box sx={{ py: 10 }}>
                <Container>

                    {/* HEADER */}
                    <Typography variant="h4" fontWeight="bold" sx={{ color: primary }}>
                        PATROCINIOS COPLAFT 2026
                    </Typography>

                    <Typography sx={{ mt: 2, mb: 6, color: "text.secondary" }}>
                        Conecta con líderes del sector financiero latinoamericano, posiciona tu marca y genera oportunidades reales de negocio en el V Congreso Latinoamericano de Prevención del Lavado de Activos y Financiamiento del Terrorismo.
                    </Typography>

                    {/* TABS */}
                    <Tabs
                        value={tab}
                        onChange={(e, val) => setTab(val)}
                        sx={{ mb: 5 }}
                        textColor="inherit"
                        indicatorColor="primary"
                    >
                        {Object.keys(levels).map((key) => (
                            <Tab
                                key={key}
                                value={key}
                                label={`${levels[key].name}`}
                                sx={{
                                    fontWeight: "bold",
                                    color: primary,
                                    fontSize: { xs: '0.7rem', md: '0.875rem' },
                                }}
                            />
                        ))}
                    </Tabs>

                    {/* NIVEL CARD */}
                    <MotionCard
                        key={tab}
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        sx={{ borderRadius: 4, p: 4, border: `2px solid ${primary}` }}
                    >
                        <Typography variant="h5" fontWeight="bold" sx={{ color: dark }}>
                            Nivel {levels[tab].name}
                        </Typography>

                        <List>
                            {levels[tab].benefits.map((b, i) => (
                                <ListItem key={i}>
                                    <ListItemIcon>
                                        <CheckCircleIcon sx={{ color: primary }} />
                                    </ListItemIcon>
                                    <ListItemText primary={b} />
                                </ListItem>
                            ))}
                        </List>
                    </MotionCard>
                    {/*<FilePreview url='https://escuela-bancaria.s3.us-east-2.amazonaws.com/1a726ee5-a9e3-4808-837e-498c62119ea5.jpeg' />*/}

                    <FilePreview url={url} />

                    {/* BENEFICIOS GENERALES */}
                    <Box mt={10}>
                        <Typography variant="h5" fontWeight="bold" sx={{ color: primary, mb: 4 }}>
                            BENEFICIOS GENERALES
                        </Typography>

                        <Grid container spacing={3}>
                            {[
                                "Posicionamiento de marca regional latinoamericana",
                                "Acceso a +250 participantes del sector financiero",
                                "Networking estratégico con reguladores y líderes AML",
                                "Exposición en medios impresos y digitales",
                                "Participación en conferencias y foros técnicos",
                            ].map((item, i) => (
                                <Grid item xs={12} md={4} key={i}>
                                    <Card sx={{ p: 3, borderRadius: 4, borderLeft: `4px solid ${primary}` }}>
                                        <Typography>{item}</Typography>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>

                    {/* PAQUETES ESPECIALES */}
                    <Box mt={10}>
                        <Typography variant="h5" fontWeight="bold" sx={{ color: primary, mb: 4 }}>
                            PAQUETES ESPECIALES
                        </Typography>

                        <Grid container spacing={4}>
                            {extras.map((item, i) => (
                                <Grid item xs={12} md={6} key={i}>
                                    <MotionCard
                                        whileHover={{ scale: 1.03 }}
                                        sx={{ borderRadius: 4, p: 3 }}
                                    >
                                        <CardContent>
                                            <Typography variant="h6" fontWeight="bold" sx={{ color: dark }}>
                                                {item.title}
                                            </Typography>

                                            <Typography variant="body2" color="text.secondary" mt={1}>
                                                {item.desc}
                                            </Typography>
                                        </CardContent>
                                    </MotionCard>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>

                    {/* CTA */}
                    <Box mt={10} textAlign="center">
                        <Typography variant="h5" fontWeight="bold" sx={{ color: dark }}>
                            ¿Listo para posicionar tu marca?
                        </Typography>

                        <Typography color="text.secondary" mt={1}>
                            Conviértete en patrocinador y conecta con los líderes del sector financiero latinoamericano.
                        </Typography>

                        <Box>
                            <Button
                                href="mailto:ncuches@ebg.edu.gt?subject=Interés%20en%20Patrocinio%20COPLAFT%202026&body=Hola%20equipo%20EBG,%0A%0AEstoy%20interesado(a)%20en%20convertirme%20en%20patrocinador%20del%20COPLAFT%202026.%20Me%20gustaría%20recibir%20más%20información%20sobre%20los%20niveles%20de%20patrocinio,%20beneficios%20y%20disponibilidad.%0A%0AEmpresa:%20%0ANombre:%20%0ACargo:%20%0ATeléfono:%20%0APaís:%20%0A%0AQuedo%20atento(a)%20a%20su%20respuesta.%0A%0ASaludos."
                                variant="contained"
                                sx={{
                                    mt: 3,
                                    display: "inline-block",
                                    px: 5,
                                    py: 2,
                                    background: primary,
                                    color: "#fff",
                                    borderRadius: 3,
                                    cursor: "pointer",
                                    fontWeight: "bold",
                                    transition: "0.3s",
                                    "&:hover": {
                                        background: dark,
                                        transform: "scale(1.05)",
                                    },
                                }}
                            >
                                Quiero ser patrocinador
                            </Button>
                        </Box>
                    </Box>
                </Container>
            </Box>
        </Stack>
    )
}

export default Patrocinio
